import React, { useContext } from 'react';
import { graphql } from 'gatsby';

import { PageMetadataContext } from '../../templates/PageMetaDataContext';
import RelatedProducts from './RelatedProducts';
import {
    BrandColor,
    CTAConfiguration,
    KontentRadioMultiChoice,
    KontentRichText,
    KontentStringValue,
    ProductFamily,
} from '../../../types/KontentProps';
import { ProductPagePreview } from '../Global/DataUtils/productQueries';

type RelatedProductContentType =
    | 'explicit_product_selection'
    | 'product_family'
    | 'product_type';

type RelatedProductCtaType = 'contact_form' | 'button';
type RelatedProductStyle = 'carousel_with_panel' | 'cards_layout';

export interface RelatedProductsProps extends CTAConfiguration {
    component_anchor_name: KontentStringValue;
    content_panel__content_panel_color: BrandColor;
    background_color: BrandColor;
    content_panel__content_panel_font_color: BrandColor;
    content_type: KontentRadioMultiChoice<RelatedProductContentType>;
    copy: KontentRichText;
    cta_type: KontentRadioMultiChoice<RelatedProductCtaType>;
    contact_form: KontentStringValue;
    product_cta_label: KontentStringValue;
    product_family: {
        value: ProductFamily[];
    };
    product_type: {
        value: {
            elements: {
                name: KontentStringValue;
                product_type: KontentRadioMultiChoice<string>;
                product_families: {
                    value: ProductFamily[];
                };
            };
        }[];
    };
    products: {
        value: ProductPagePreview[];
    };
    show_colored_panel: KontentRadioMultiChoice<'yes' | 'no'>;
    style: KontentRadioMultiChoice<RelatedProductStyle>;
}

const RelatedProductsContainer: React.FC<RelatedProductsProps> = (props) => {
    const pageContext = useContext(PageMetadataContext);

    return <RelatedProducts {...props} currentPageSlug={pageContext.slug} />;
};

export default RelatedProductsContainer;

export const fragmentRelatedProducts = graphql`
    fragment RelatedProducts on kontent_item_component___related_products {
        elements {
            component_anchor_name {
                value
            }
            content_panel__content_panel_color {
                ...kontentColor
            }
            background_color {
                ...kontentColor
            }
            content_panel__content_panel_font_color {
                ...kontentColor
            }
            content_type {
                value {
                    codename
                    name
                }
            }
            copy {
                ...kontentRichText
            }
            cta_configuration__cta_label {
                value
            }
            cta_configuration__cta_location {
                ...kontentCtaLocation
            }
            cta_configuration__cta_location_anchor_point {
                value
            }
            cta_configuration__cta_window_action {
                value {
                    codename
                }
            }
            cta_type {
                value {
                    codename
                }
            }
            contact_form {
                value
            }
            product_cta_label {
                value
            }
            product_family {
                value {
                    ...kontentProductFamily
                }
            }
            product_type {
                value {
                    ... on kontent_item_data___product_type {
                        elements {
                            name {
                                value
                            }
                            product_type {
                                value {
                                    codename
                                    name
                                }
                            }
                            product_families {
                                value {
                                    ...kontentProductFamily
                                }
                            }
                        }
                    }
                }
            }
            products {
                value {
                    ...productPagePreview
                }
            }
            show_colored_panel {
                value {
                    codename
                }
            }
            style {
                value {
                    codename
                }
            }
        }
    }
`;
